import { useFormContext } from "react-hook-form";

import Button from "@components/Button";
import { InputField } from "@components/Field";
import Typography from "@components/Typography";

import styles from "../../SignupView.module.css";

const OrganizationInfo = () => {
  const { register } = useFormContext();
  return (
    <div className={styles.container}>
      <Typography variant="h1" block align="center" className={styles.title}>
        {L.SIGN_UP_ORGANIZATION_INFO_TITLE}
      </Typography>
      <InputField
        {...register("organization_name", {
          required: {
            value: true,
            message: L.REQUIRED_FIELD_VALUE,
          },
        })}
        block
        autoFocus
        label={L.SIGN_UP_ORGANIZATION_NAME}
      />

      <Button block type="submit">
        {L.SIGN_UP_FINISH_CTA}
      </Button>
    </div>
  );
};

export default OrganizationInfo;
